import React, { useState } from "react";
import Map, { Source, Layer, Popup, NavigationControl } from "react-map-gl";
import "./TrafficIndex.css";
import moment from "moment";
import imsc from "./imsc.png";
import Axios from "axios";
import { css } from "@emotion/react";
import RiseLoader from "react-spinners/RiseLoader";

const override = css`
  position: absolute;
  z-index: 10;
  bottom: 2rem;
  right: 1rem;
`;

const layerStyle1 = {
  id: "polygon",
  type: "fill",
  paint: {
    "fill-color": "#990000",
    "fill-opacity": 0.5,
  },
};

const layerStyle2 = {
  id: "points",
  type: "circle",
  paint: {
    "circle-radius": 5,
    "circle-color": "#990000",
    "circle-opacity": 0.5,
  },
};

function Reachability() {
  const [lat, setlat] = useState(34.0224);
  const [long, setlong] = useState(-118.2851);
  const [date, setdate] = useState("2022-08-01");
  const [time, settime] = useState("19:00");
  const [method, setmethod] = useState("Convex Hull");
  const [loading, setLoading] = useState(false);
  const [deadline, setdeadline] = useState("5");
  const [data, setdata] = useState({
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        geometry: { type: "Point", coordinates: [long, lat] },
      },
    ],
  });
  const handleOnClick = (event) => {
    setLoading(true);
    setlat(event.lngLat.lat);
    setlong(event.lngLat.lng);
    Axios.post("/api/reachability/", {
      Latitude: event.lngLat.lat,
      Longitude: event.lngLat.lng,
      Date: date,
      Time: time,
      Deadline: deadline,
      Method: method,
    }).then((response) => {
      setLoading(false);
      setdata(response.data);
    });
  };
  return (
    <div>
      <RiseLoader
        color={"#990000"}
        loading={loading}
        size={20}
        css={override}
      />
      <input
        class="input1"
        type="date"
        max={moment().format("YYYY-MM-DD")}
        value={date}
        onChange={(event) => {
          setdate(event.target.value);
        }}
      ></input>
      <input
        class="input2"
        type="time"
        value={time}
        step="3600"
        onChange={(event) => {
          settime(event.target.value);
        }}
      ></input>
      <select
        class="select2"
        onChange={(event) => {
          setmethod(event.target.value);
        }}
      >
        <option value="Convex Hull">Convex Hull</option>
        <option value="Raw">Raw</option>
        <option value="Cells">Cells</option>
        <option value="Trajectories">Trajectories</option>
        <option value="Buffers">Buffers</option>
      </select>
      <select
        class="select3"
        onChange={(event) => {
          setdeadline(event.target.value);
        }}
      >
        <option value="5">5 minutes</option>
        <option value="10">10 minutes</option>
        <option value="15">15 minutes</option>
        <option value="20">20 minutes</option>
        <option value="25">25 minutes</option>
        <option value="30">30 minutes</option>
        <option value="35">35 minutes</option>
        <option value="40">40 minutes</option>
      </select>
      <img class="img1" src={imsc} alt="" />
      <Map
        initialViewState={{
          longitude: long,
          latitude: lat,
          zoom: 12,
        }}
        onClick={handleOnClick}
        style={{ width: "100vw", height: "100vh" }}
        mapStyle="mapbox://styles/mapbox/streets-v9"
        mapboxAccessToken="pk.eyJ1IjoiY2FuYXN0YXNpb3UiLCJhIjoiY2w0ZXowc2ZiMDc0bDNqbzFxZWp6M2ttciJ9.AlAcpimbT_J99eRS_dYKog"
      >
        <Source id="my-data1" type="geojson" data={data}>
          <Layer {...layerStyle1} />
          {/* <Layer {...layerStyle2} /> */}
        </Source>
        <Source id="my-data2" type="geojson" data={data}>
          <Layer {...layerStyle2} />
        </Source>
        <Popup
          longitude={long}
          latitude={lat}
          closeOnClick={false}
          anchor="left"
        >
          <div style={{ display: "inline" }}>
            <p class="h1">
              Latitude: <span class="value">{lat}</span>
            </p>
            <p class="h1">
              Longitude: <span class="value">{long}</span>
            </p>
            <p class="h1">
              Time to travel: <span class="value">{deadline} minutes</span>
            </p>
            <p class="h1">
              Output Format: <span class="value">{method}</span>
            </p>
          </div>
        </Popup>
        <NavigationControl />
      </Map>
    </div>
  );
}

export default Reachability;
